import {useContext} from 'react'
import {CustomerReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {CUSTOMER_TYPE_REPORT_COLUMNS} from '../../utils'
import CustomerTypeReportRow from './CustomerTypeReportRow'
import {parseCustomerTypeReportRow} from '../../parsings'
import {formatPrice} from '../../../../utils/common'
import CustomerTypeTableHeader from '../header/CustomerTypeTableHeader'

const CustomerTypeReportTable = () => {
  const {
    customerTypeData,
    isCustomerTypeLoading,
    customerTypeFilters,
    onCustomerTypeSortingChange,
  } = useContext(CustomerReportContext)

  return (
    <div className='card border mb-10'>
      <div className='card-body p-7'>
        <CustomerTypeTableHeader />
        <DynamicTable
          data={customerTypeData}
          sortableColumns={CUSTOMER_TYPE_REPORT_COLUMNS}
          loading={isCustomerTypeLoading}
          TableRow={CustomerTypeReportRow}
          noDataMessage='No customer type reports found'
          tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
          rowParsingFunction={parseCustomerTypeReportRow}
          filters={customerTypeFilters}
          onSortingChange={onCustomerTypeSortingChange}
          tableFooter={({columnTotals}: any) => (
            <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
              <tr>
                <td>TOTAL</td>
                <td>{columnTotals?.total_order_count}</td>
                <td>{formatPrice(columnTotals.total_shipping, false)}</td>
              </tr>
            </tfoot>
          )}
        />
      </div>
    </div>
  )
}

export default CustomerTypeReportTable
